export default __webpack_public_path__ + "static/media/main_bg.5ae11474.png";